export { default as PopularCategory } from './PopularCategory';



// WEBPACK FOOTER //
// ./src/containers/HomePage/PopularCategories/PopularCategory/index.ts